import React from "react";
import "../../styles/About/AboutPageBanner.scss";
import onBannerImage from "../../assets/images/onBannerImage.png";
import { Col, Container, Row } from "react-bootstrap";

const AboutPageBanner = () => {
  return (
    <div id="who" className="body">
      <div className="banner-image-container">
        <div className="banner-image">
          <div className="foreground-image">
            <span>
              <img src={onBannerImage} alt="" loading="lazy" />
            </span>
          </div>
          <Container fluid className="p-0">
            {/* <Row className="align-items-center justify-content-center ">
              <Col md={6}></Col>
              <Col md={6} className="vh-100  text-end">
                <div className="about-section py-5 d-flex align-items-center justify-content-center flex-column text-start">
                  <div className="about-title "></div>

                  <p className="about-description">
                    New is normal and art is exceptional, after years of art
                    cultivation in detail, MEZRO was born. “Imagine Truly” is
                    our motto! Marketing is not just advertising and promotion
                    or selling strategy, it's beyond that. It's an art! We
                    believe in working with detail and we don't stop until it
                    becomes a masterpiece.
                  </p>
                </div>
              </Col>
            </Row> */}
            <div className="about-section py-5 d-flex align-items-center justify-content-center">
              <div className="about-title "></div>

              <p className="about-description">
                New is normal and art is exceptional, after years of art
                cultivation in detail, MEZRO was born. “Imagine Truly” is our
                motto! Marketing is not just advertising and promotion or
                selling strategy, it's beyond that. It's an art! We believe in
                working with detail and we don't stop until it becomes a
                masterpiece.
              </p>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default AboutPageBanner;
